module.exports = "./img/d89efd3bf2af4add4a144a296aa3f5bd.jpg";